import React from 'react'
import { Box, Typography } from '@mui/material'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css/pagination';
import 'swiper/css';
import { Pagination } from 'swiper/modules';
import slidimge1 from "../assets/back.png";
import slidimge2 from "../assets/back1.png";
import slidimge3 from "../assets/back2.png";
import slidimge4 from "../assets/back3.png";

const WeCear = () => {
    return (
        <>
            <div className='WeCare_slider'>
                <Swiper
                    spaceBetween={30} pagination={{ clickable: true, }}
                    modules={[Pagination]} className="mySwiper">
                   <div>
                   <SwiperSlide>
                        <div className="WecearMain" style={{ backgroundImage: `url(${slidimge1})` }}>
                            <div className="text_swipe" >
                                <h1 className='slider_titls'>Why Choose <span style={{ color: "#7FF1EA" }}>WeCare</span>?</h1>
                              <p   className='slider_caption'>Our top-rated boiler cover provides one of the best <br /> value
                                    offerings on the market.</p>
                            </div>
                            <div className="text_swipe">
                                <h1 className='slider_titls'>Great Value</h1>
                               <p  className='slider_caption'>  Switching to WeCare could save you over 40% in less than 4 minutes on
                                    <br /> your renewal quote compared with other providers</p>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="WecearMain" style={{ backgroundImage: `url(${slidimge2})` }}>
                            <div className="text_swipe" >
                                <h1  className='slider_titls'>Why Choose <span style={{ color: "#7FF1EA" }}>WeCare
                                </span>?</h1>
                                <p className='slider_caption'>Our top-rated boiler cover provides one of the best <br/>value offerings on the market.</p>
                            </div>
                            <div className="text_swipe">
                                <h1 className='slider_titls'>No More Price Hikes</h1>
                                <p className='slider_caption'>WeCare fix your monthly price for up to 3 years, no matter how many<br/> home repairs we carry out.</p>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="WecearMain" style={{ backgroundImage: `url(${slidimge3})` }}>
                            <div className="text_swipe" >
                                <h1 className='slider_titls'>Why Choose <span style={{ color: "#7FF1EA" }}>WeCare
                                </span>?</h1>
                                <p className='slider_caption'>Our top-rated boiler cover provides one of the best <br/> value offerings on the market.</p>
                            </div>
                            <div className="text_swipe">
                                <h1 className='slider_titls' >24/7 Repair Booking</h1>
                                <p className='slider_caption'>We've made it super-fast to book a repair 24/7 online using any device,<br/> or over the phone via our UK based contact centre.</p>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="WecearMain" style={{ backgroundImage: `url(${slidimge4})` }}>
                            <div className="text_swipe" >
                                <h1 className='slider_titls'>Why Choose <span style={{ color: "#7FF1EA" }}>WeCare
                                </span>?</h1>
                                <p className='slider_caption'>Our top-rated boiler cover provides one of the best <br/> value offerings on the market.</p>
                            </div>
                            <div className="text_swipe">
                                <h1 className='slider_titls' >Unlimited Repairs</h1>
                                <p className='slider_caption'>Book as many repairs as you need, there's no limit on the value of each <br/>repair and all parts and labour are included.</p>
                            </div>
                        </div>
                    </SwiperSlide>
                   </div>
                </Swiper>
            </div>

        </>
    )

}

export default WeCear
